import { makeQuery } from 'shared/utilities';
import { IEntryPassModel } from 'shared/models';

type ResponseType = {
    item: IEntryPassModel;
};

export const entryPassesCreateQuery = async function (body: IEntryPassModel) {
    return await makeQuery<ResponseType>('/entry-passes/create', {
        method: 'POST',
        json: body
    });
}
